import { render, staticRenderFns } from "./modalAgendamento.component.html?vue&type=template&id=5088f4ab&scoped=true&"
import script from "./ModalAgendamento.vue?vue&type=script&lang=ts&"
export * from "./ModalAgendamento.vue?vue&type=script&lang=ts&"
import style0 from "./modalAgendamento.component.scss?vue&type=style&index=0&id=5088f4ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088f4ab",
  null
  
)

export default component.exports